import {AxiosInstance, AxiosResponse} from "axios";
import {
    ASAFOCustomerSearchResult,
    ASAFOSearchParams,
    ASAFOSearchResult,
    FraudReportCustomer
} from "@/core/interfaces/fraud/fraud";

/**
 * The ASAFO Api resource.
 * @param {Object} client - The injected client.
 */
export default function (client: AxiosInstance) {
    return {
        /**
         * Get all Fraud Reports.
         *
         * @param {ASAFOSearchParams} params The search params.
         */
        async reports(params: ASAFOSearchParams = {}): Promise<ASAFOSearchResult> {
            return await client.get('fraud-reports', {params})
                .then((response: AxiosResponse) => response.data)
                .catch(() => []);
        },
        /**
         * Get all Fraud Report Customers.
         *
         * @param {ASAFOSearchParams} params The search params.
         */
        async customers(params: ASAFOSearchParams = {}): Promise<ASAFOCustomerSearchResult> {
            return await client.get('fraud-report-customers', {params})
                .then((response: AxiosResponse) => response.data)
                .catch(() => []);
        },
        /**
         * Read a Fraud Report Customer.
         *
         * @param fraudReportCustomerId  The fraud report customer ID.
         */
        async readCustomer(fraudReportCustomerId: number): Promise<FraudReportCustomer> {
            return await client.get(`fraud-report-customers/${fraudReportCustomerId}`)
                .then((response: AxiosResponse) => response.data.data)
                .catch(() => []);
        },
    };
}
